module.exports = __webpack_public_path__ + "img/switchable-corporation-account.d424acd.png";